/* ============================================================
   FRAISE NOIRE — LES TEINTES DE CASQUETTE
   ------------------------------------------------------------
   Table de correspondance entre une couleur et les casquettes qui
   la portent. Elle alimente le filtre Couleur de la page boutique.

   LA CONVENTION — à respecter si on ajoute une pièce :
     • toute casquette est rangée sous la couleur de sa CALOTTE ;
     • elle est EN PLUS rangée sous la couleur de son MOTIF quand
       ce motif est un accent distinctif (fraise dorée, abeille
       violette). Un motif noir, blanc cassé ou argenté ne crée pas
       d'entrée : sinon « Noir » contiendrait tout le catalogue.

   PIÈGE À NE PAS OUBLIER : le nom d'une casquette désigne la
   couleur de la FRAISE (ou de l'ABEILLE), pas celle de la
   casquette. « Blue Magic » est NOIRE, mesurée RGB(17,16,15).
   Les six Abeille sont toutes noires. Et le handle mentit aussi :
   « Classics Iron » vit sous `casquette-rouge-fraise-argent`.
   Ne jamais déduire une couleur d'un nom ni d'une URL : mesurer
   l'image.

   CONSÉQUENCE SI UNE PIÈCE MANQUE ICI : dans shop.js elle sort de
   la grille au premier clic sur une pastille — elle devient
   introuvable sans aucun message. Six casquettes étaient dans ce
   cas avant le 20/10/2026.

   Fichier produit par scripts/construire_couleurs.py — modifier la
   table là-bas plutôt qu'ici, le script vérifie que les 36 pièces
   actives sont couvertes.
   ============================================================ */

window.FN_COLORS = [
  { k: 'noir', label: 'Noir', sw: '#141414',
    h: ['casquette-abeille-bleue', 'casquette-abeille-jaune', 'casquette-abeille-orange', 'casquette-abeille-rose', 'casquette-abeille-verte', 'casquette-abeille-violette', 'casquette-ajustable-black-zefrai-fraise-noire-2023', 'casquette-ajustable-blue-magic', 'casquette-ajustable-rien-100-rien-fraise-noire-2023', 'casquette-ajustable-style-trucker-fraise-noire-2023', 'casquette-brodee-3d-ajustable-black', 'casquette-fraise-gold', 'casquette-fraise-gold-hologramme', 'casquette-fraise-hologramme', 'casquette-fraise-menthe', 'casquette-fraise-noire-pailletee', 'casquette-fraise-rose-paillettes', 'casquette-noire-ajustable-style-trucker-fraise-noire-2023', 'casquette-personnalisable-fraise-noire'] },   /* 19 pièce(s) */
  { k: 'blanc', label: 'Blanc', sw: '#F5F4F2',
    h: ['casquette-blanche-ajustable-style-trucker-fraise-noire-2023', 'casquette-blanche-fraise-ice', 'casquette-blanche-fraise-noire', 'casquette-blanche-fraise-turquoise', 'casquette-brodee-3d-ajustable-white'] },   /* 5 pièce(s) */
  { k: 'gris', label: 'Gris', sw: '#9A9A9A',
    h: ['casquette-ajustable-classics-black-copie', 'casquette-ajustable-classics-black-copie-1'] },   /* 2 pièce(s) */
  { k: 'beige', label: 'Beige', sw: '#D8CDBB',
    h: ['casquette-ajustable-classics-wood'] },   /* 1 pièce(s) */
  { k: 'rouge', label: 'Rouge', sw: '#D52B1E',
    h: ['casquette-brodee-3d-ajustable-red', 'casquette-rouge-ajustable-style-trucker-fraise-noire-2023', 'casquette-rouge-fraise-argent'] },   /* 3 pièce(s) */
  { k: 'rose', label: 'Rose', sw: '#E8A0B4',
    h: ['casquette-abeille-rose', 'casquette-ajustable-classics-pink', 'casquette-blanche-ajustable-style-trucker-fraise-noire-2023', 'casquette-brodee-3d-ajustable-classics-pink', 'casquette-fraise-gold', 'casquette-fraise-rose-paillettes'] },   /* 6 pièce(s) */
  { k: 'orange', label: 'Orange', sw: '#E8742C',
    h: ['casquette-abeille-orange', 'casquette-fraise-gold', 'casquette-kaki-fraise-fluo'] },   /* 3 pièce(s) */
  { k: 'jaune', label: 'Jaune', sw: '#E8C53C',
    h: ['casquette-abeille-jaune', 'casquette-fraise-gold'] },   /* 2 pièce(s) */
  { k: 'vert', label: 'Vert', sw: '#5B6B4A',
    h: ['casquette-abeille-verte', 'casquette-ajustable-classics-black-copie-2', 'casquette-kaki-ajustable-style-trucker-fraise-noire-2023', 'casquette-kaki-fraise-fluo'] },   /* 4 pièce(s) */
  { k: 'bleu', label: 'Bleu', sw: '#2E5C8A',
    h: ['casquette-abeille-bleue', 'casquette-ajustable-blue-magic', 'casquette-ajustable-classics-blue-navy', 'casquette-blanche-fraise-ice', 'casquette-blanche-fraise-turquoise', 'casquette-fraise-menthe'] },   /* 6 pièce(s) */
  { k: 'violet', label: 'Violet', sw: '#8A6BAF',
    h: ['casquette-abeille-violette'] },   /* 1 pièce(s) */
  { k: 'or', label: 'Or & holo', sw: 'linear-gradient(135deg,#D8B25C 0%,#EDE6F2 60%,#C9C4CE 100%)',
    h: ['casquette-fraise-gold-hologramme', 'casquette-fraise-hologramme'] },   /* 2 pièce(s) */
];
